import { createFileRoute, redirect } from '@tanstack/react-router'
import { guardTeacherOnly } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/teacher/attandencehistory')({
  beforeLoad: guardTeacherOnly,
  loader: () => {
    throw redirect({
      to: '/teacher/attendance',
      search: { tab: 'history' },
    })
  },
})
